import React from "react";
import {
  Checkbox,
  Radio,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import styles from "./../ListItem.module.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function OpenOrCloseButton({ open }: { open: boolean }) {
  if (open) {
    return <KeyboardArrowUpIcon />;
  } else {
    return <KeyboardArrowDownIcon />;
  }
}

type LayerListItemProps = {
  label: React.ReactNode;
  active: boolean;
  onActivate: () => void;
  children?: React.ReactNode;
  widget?: "radio" | "checkbox";
};

export default function LayerListItem({
  label,
  active,
  onActivate,
  children,
  widget = "checkbox",
}: LayerListItemProps): React.ReactNode {
  const Widget = widget === "checkbox" ? Checkbox : Radio;
  return (
    <>
      <ListItem
        className={styles.listItem}
        onClick={() => widget === "checkbox" && onActivate()}
        secondaryAction={
          children && (
            <IconButton edge="end">
              <OpenOrCloseButton open={active} />
            </IconButton>
          )
        }
      >
        <ListItemButton onClick={() => onActivate()}>
          <ListItemIcon sx={{ minWidth: 0 }}>
            <Widget edge="start" disableRipple checked={active} />
          </ListItemIcon>
          <ListItemText primary={label} />
        </ListItemButton>
      </ListItem>
      {active && children}
    </>
  );
}
